import React, { useState, useEffect } from 'react'
import {
    Button, Alert, Flex, Badge, Form,
    Checkbox, Input, Upload, Select, Card, Divider, Breadcrumb, Steps,
    Image
} from 'antd'
import api, { BASEURL } from '../../../service/axios'
import { useToasts } from 'react-toast-notifications';
import {
    CheckOutlined,
    CloseOutlined,
    UploadOutlined,
    FileTextOutlined,
    SendOutlined,
    RightOutlined,
    DownloadOutlined
} from '@ant-design/icons';
import { userState } from '../../../service/database'
import { useRecoilState } from 'recoil'
import InputMask from 'react-input-mask';
import GOVBR from '../../../images/gov.png'


export const CRTNova = (props) => {

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false)
    const { addToast } = useToasts()
    const [user,] = useRecoilState(userState)
    const [solicitacao, setSolicitacao] = useState(props.selected)
    // const [valEtapa1, setValEtapa1] = useState(false)
    const razaoObservable = Form.useWatch('razao', form)
    const enderecoObservable = Form.useWatch('endereco', form)
    const bairroObservable = Form.useWatch('bairro', form)
    const crqObservable = Form.useWatch('crq', form)
    const statusObservable = Form.useWatch('status', form)
    const cnpjObservable = Form.useWatch('cnpj', form)
    const outrasObservable = Form.useWatch('outras', form)



    const items = [
        {
            title: <b>Etapa 1</b>,
            content: <Flex style={{ color: 'gray', fontSize: '0.9em' }}>Dados da Solicitação</Flex>,
        },
        {
            title: <b>Etapa 2</b>,
            content: <Flex style={{ color: 'gray', fontSize: '0.9em' }}>Assinar Formulário</Flex>,
        },
        {
            title: <b>Etapa 3</b>,
            content: <Flex style={{ color: 'gray', fontSize: '0.9em' }}>Arquivos</Flex>,
        },
        {
            title: <b>Etapa 4</b>,
            content: <Flex style={{ color: 'gray', fontSize: '0.9em' }}>Concluir</Flex>,
        },
    ];


    useEffect(() => {
        form.setFieldValue('status', false)
    }, [cnpjObservable])


    function renderEtapas() {
        switch (solicitacao.etapa) {
            case 0:
                return renderEtapa1()
            case 1:
                return renderEtapa2()
            case 2:
                return renderEtapa3()
            default:
                return renderEtapa4()
        }
    }

    const onFinish = async values => {

        try {
            let _solicitacao = JSON.parse(JSON.stringify(values))
            _solicitacao.etapa = 1
            setLoading(true)
            const result = await api.post('/api/v1.0/registrado/crt', _solicitacao,
                {
                    headers: {
                        'x-access-token': user?.token2
                    },
                    params: {
                        cnpj: solicitacao.cnpj
                    }
                }
            )

            setSolicitacao(result.data)

        } catch (error) {
            addToast(error.message, { appearance: 'error', autoDismiss: true })
        }
        setLoading(false)



        /*
        if (values.viapj === 1 && values.realizado.status !== true) {
            addToast("Informe o CNPJ da empresa que realizou o serviço e clique em validar!", { autoDismiss: true, appearance: 'warning' })
            return
        }

        values.firmaid = values.realizado?.firmaid
        values.cep = values.contratante?.cep
        */
        //  console.log(values);
        //saveSolicitacao(values)
    };

    const onFailed = values => {
        if (!statusObservable)
            addToast("O CNPJ não foi validado!", { appearance: 'error', autoDismiss: true })
        console.log(values)
    };

    function renderEtapa1() {
        return <Card size='small' title={null}>

            <Form
                initialValues={solicitacao}
                layout='vertical'
                form={form}
                name="control-hooks"
                onFinish={onFinish}
                onFinishFailed={onFailed}>

                <Form.Item style={{ display: 'fiid' }} rules={[{ required: true, message: 'Esse campo é obrigatório!' }]} name={'fiid'} noStyle />
                <Form.Item style={{ display: 'none' }} rules={[{ required: true, message: 'Esse campo é obrigatório!' }]} name={'razao'} noStyle />
                <Form.Item style={{ display: 'none' }} rules={[{ required: true, message: 'Esse campo é obrigatório!' }]} name={'endereco'} noStyle />
                <Form.Item style={{ display: 'none' }} rules={[{ required: true, message: 'Esse campo é obrigatório!' }]} name={'bairro'} noStyle />
                <Form.Item style={{ display: 'none' }} rules={[{ required: true, message: 'Esse campo é obrigatório!' }]} name={'crq'} noStyle />
                <Form.Item style={{ display: 'none' }} rules={[{
                    required: true, type: 'boolean',
                    transform: (value) => value || undefined,
                    message: 'Esse campo é obrigatório!'
                }]} name={'status'} />

                <Flex>Informe o CNPJ da empresa</Flex>
                <Form.Item style={{ display: 'none' }} name={'id'} noStyle />
                <Flex align='center' gap={10}>
                    <Form.Item
                        rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}
                        name={'cnpj'}
                        label={""}>
                        <InputMask
                            style={{ width: 200 }}
                            mask={"99.999.999/9999-99"}
                            placeholder={"99.999.999/9999-99"}>
                            {(inputProps) => <Input {...inputProps} />}
                        </InputMask>
                    </Form.Item>
                    <Form.Item >
                        <Button
                            loading={loading}
                            type='primary'
                            onClick={async () => {
                                try {
                                    const _cnpj = form.getFieldValue('cnpj')
                                    setLoading(true)
                                    const result = await api.get('/api/v1.0/registrado/firma/validar',
                                        {
                                            headers: {
                                                'x-access-token': user?.token2
                                            },
                                            params: {
                                                cnpj: _cnpj
                                            }
                                        }
                                    )

                                    if (result.data.status === true) {
                                        console.log(result.data)
                                        form.setFieldsValue({
                                            ...form.getFieldsValue(),
                                            razao: result.data.razao,
                                            endereco: result.data.endereco,
                                            bairro: result.data.bairro,
                                            crq: result.data.crq,
                                            status: result.data.status,
                                            outras: result.data.outras,
                                            fiid: result.data.fiid
                                        })

                                        //  setSolicitacao({ ...solicitacao, ...result.data })
                                    } else {
                                        form.setFieldValue('status', false)
                                        addToast("Não é possível efetuar a Comunicação de Responsabilidade Técnica para a Empresa "
                                            .concat(result.data.razao, ', entre em contato com o CRQ10/CE para mais informações!'),
                                            {
                                                appearance: 'error', autoDismiss: true
                                            }
                                        )
                                    }
                                } catch (error) {
                                    form.setFieldsValue({
                                        ...form.getFieldsValue(),
                                        razao: '',
                                        endereco: '',
                                        bairro: '',
                                        crq: '',
                                        status: ''
                                    })
                                    if (error.message === 'Request failed with status code 404')
                                        addToast("Nenhum registro localizado para o CNPJ informado, verifique se realmente a empresa possui registro junto ao CRQ10/CE!", { appearance: 'error', autoDismiss: true })
                                    else
                                        addToast(error.message, { appearance: 'error', autoDismiss: true })

                                }
                                setLoading(false)

                            }}>Validar Empresa</Button>
                    </Form.Item>
                </Flex>



                {
                    statusObservable === true && <Card size='small' style={{ backgroundColor: '#fcfcfc' }}>
                        <Flex vertical gap={0}>
                            <Flex gap={5}><CheckOutlined style={{ color: 'green' }} />  <b>{razaoObservable}</b></Flex>
                            <Flex style={{ marginLeft: 20 }}>{enderecoObservable}, {bairroObservable}</Flex>
                            <Flex style={{ marginLeft: 20 }}>Registro: {crqObservable}</Flex>
                        </Flex>
                    </Card>
                }

                <Form.Item
                    rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}
                    name={'atividade'}
                    label={"Descreva as atividades relacionadas à área da Química que são desenvolvidas por você na empresa ".concat(razaoObservable)}>
                    <Input.TextArea
                        maxLength={500}
                        rows={5}
                        placeholder='Atuo na área da Química, desenvolvendo atividades relacionadas ao acompanhamento e controle de processos laboratoriais, realização e acompanhamento de análises físico-químicas, preparação e controle de soluções e reagentes, interpretação e avaliação de resultados analíticos, controle de qualidade e elaboração de registros e relatórios técnicos. Também participo da supervisão das atividades realizadas no laboratório, assegurando o cumprimento dos procedimentos técnicos e das normas aplicáveis à atividade.'
                        value={solicitacao.atividade}
                        onChange={(e) => setSolicitacao({ ...solicitacao, atividade: e.target.value })} />
                </Form.Item>


                <Form.Item
                    rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}
                    name={'horas'}
                    label={<div>
                        <div><b>{razaoObservable}</b></div>
                        <div style={{ color: 'gray' }}>Dias e horários que irá desenvolver as atividades de Responsabilidade Técnica</div>
                    </div>}>
                    <Input.TextArea
                        allowClear={false}
                        placeholder='Exemplo: Segunda de 08:00 às 12:00h'
                        style={{ minWidth: 70 }} />
                </Form.Item>



                <Form.List name="outras" >
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, ...restField }) => {
                                const firstName = form.getFieldValue(['outras', name, 'razao']) || 'razao';
                                // console.log(firstName)
                                return <Flex vertical>

                                    <Form.Item name={[name, 'fiid']} style={{ display: 'none' }} />
                                    <Form.Item name={[name, 'cnpj']} style={{ display: 'none' }} />


                                    <Form.Item
                                        style={{ display: statusObservable === true ? 'block' : 'none' }}
                                        {...restField}
                                        name={[name, 'horarios']}
                                        label={<div>
                                            <div><b>{firstName}</b></div>
                                            <div style={{ color: 'gray' }}>Dias e horários que irá desenvolver as atividades de Responsabilidade Técnica</div>
                                        </div>}
                                        rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}
                                    >
                                        <Input placeholder="Exemplo: Segunda de 08:00 às 12:00h" />
                                    </Form.Item>
                                </Flex>

                            })}
                        </>
                    )}



                    {/*
                        solicitacao?.outras?.map((item, index) => {
                            return <Flex vertical key={item.razao} style={{ marginBottom: 10 }}>
                                <Flex gap={3} vertical style={{ lineHeight: 1 }}>
                                    <b>{item.razao}:</b>
                                    <div style={{ fontStyle: 'italic', fontSize: '0.9em', color: 'gray', marginBottom: 2 }}>
                                        <span style={{ color: 'red' }}>* </span>
                                        Dias e horários que irá desenvolver as atividades de Responsabilidade Técnica </div>
                                </Flex>
                                <Input.TextArea
                                    value={item.horarios}
                                    onChange={(e) => {
                                        var _solicitacao = JSON.parse(JSON.stringify(solicitacao))
                                        var _item = _solicitacao.outras[index]
                                        _item.horarios = e.target.value
                                        setSolicitacao({ ..._solicitacao })

                                    }}
                                    allowClear={false}
                                    placeholder='Exemplo: Segunda de 08:00 às 12:00h'
                                    style={{ minWidth: 70 }} />
                            </Flex>
                        })
                      */  }



                </Form.List>

                <Alert
                    title={<b>Declaração de Compatibilidade de Horários e Vínculos Profissionais</b>}
                    description={<div>
                        <div>Eu, na condição de profissional registrado neste Conselho Regional de Química, declaro, para os devidos fins, que mantenho vínculo(s) contratual(is)
                            com pessoa(s) jurídica(s), exercendo atividades técnicas compatíveis com minhas atribuições profissionais.</div>
                        <div style={{ marginBottom: 10 }}>Em atendimento às exigências deste Conselho, informo que descrevo de forma detalhada os dias e horários de
                            prestação de serviços relativos a cada contrato firmado, conforme discriminado abaixo, de modo a evidenciar a compatibilidade de horários e a
                            regularidade do exercício efetivo das Responsabilidades Técnicas por mim desempenhadas.</div>
                        <div>O tempo de deslocamente entre as empresas será considerado.</div>
                    </div>} style={{ marginBottom: 10, display: statusObservable === true ? 'block' : 'none' }} />



                <Flex>Declaro, ainda, que os horários acima informados não se sobrepõem, sendo plenamente compatíveis entre si, garantindo o adequado desempenho das atividades técnicas assumidas, em conformidade com a legislação vigente e as normas estabelecidas pelo Sistema CFQ/CRQs.</Flex>
                <Flex>Por fim, assumo inteira responsabilidade pelas informações prestadas, estando ciente de que a omissão ou prestação de
                    informações inverídicas poderá ensejar o indeferimento da Responsabilidade Ténica Informada, bem assim a apuração/aplicação de sanções
                    administrativas, éticas e legais cabíveis.</Flex>

                <Flex justify='flex-end' gap={10} align='center' style={{ marginTop: 10 }}>
                    <Button
                        htmlType='submit'
                        loading={loading}
                        type='primary' iconPlacement='end' icon={<RightOutlined />}>Continuar</Button>
                </Flex>

            </Form>

        </Card>
    }

    function renderEtapa2() {
        return <Flex vertical gap={10}>
            <Card  >
                <div>
                    Informamos que o profissional deverá efetuar o download do formulário previamente preenchido com os dados informados no sistema,
                    realizando, em seguida, a assinatura digital do documento, tanto pelo próprio profissional quanto pela empresa responsável.
                </div>
                <div style={{ marginTop: 10 }}>
                    Caso não possuam certificado digital, orienta-se que a assinatura seja realizada por meio da plataforma <a href='https://assinador.iti.br/assinatura/index.xhtml' target='_blank'>
                        gov.br</a>, que disponibiliza a
                    funcionalidade de assinatura eletrônica válida e reconhecida legalmente.
                </div>

                <Flex align='center' style={{ marginTop: 10 }} gap={20}>
                    <Button
                        icon={<DownloadOutlined />}
                        onClick={async () => {
                            try {
                                const result = await api.get('/api/v1.0/registrado/ccrt/formulario',
                                    {
                                        headers: {
                                            'x-access-token': user?.token2
                                        },
                                        params: {
                                            id: solicitacao.id
                                        },
                                        responseType: 'blob'
                                    }
                                )
                                const pdfBlob = new Blob([result.data], { type: "application/pdf" });
                                // Cria uma URL temporária para o Blob 
                                const url = window.URL.createObjectURL(pdfBlob);
                                // Cria         um elemento <a> temporário para iniciar o download 
                                const tempLink = document.createElement("a");
                                tempLink.href = url;
                                tempLink.setAttribute("download", "ccrt".concat('.pdf'));
                                // Define o nome de arquivo desejado para o arquivo baixado 
                                // Adiciona o elemento <a> ao corpo e clica nele para iniciar o download 
                                document.body.appendChild(tempLink);
                                tempLink.click();
                                // Limpa os elementos temporários e a URL 
                                document.body.removeChild(tempLink);
                                window.URL.revokeObjectURL(url);


                            } catch (error) {
                                addToast(error, {
                                    autoDismiss: true,
                                    appearance: 'error'
                                })
                            }

                        }}>Formulário
                    </Button>

                    <a href='https://assinador.iti.br/assinatura/index.xhtml' style={{ marginTop: 10 }} target='_blank'>
                        <Image preview={false} src={GOVBR} width={105} style={{ objectFit: 'contain' }} />
                    </a>
                </Flex>

                <Flex style={{ marginTop: 12 }}>Se já baixou e assinou o contrato clique em continuar</Flex>

            </Card>



            <Flex justify='flex-end' gap={30} style={{ marginTop: 30 }}>
                <Button onClick={() => {
                    setSolicitacao({ ...solicitacao, etapa: 0 })
                    form.setFieldsValue(solicitacao)
                }}
                >Voltar</Button>
                <Button
                    loading={loading}
                    iconPlacement='end' icon={<RightOutlined />}
                    type='primary' onClick={async () => {
                        try {
                            let _solicitacao = JSON.parse(JSON.stringify(solicitacao))
                            _solicitacao.etapa = 2
                            setLoading(true)
                            const result = await api.post('/api/v1.0/registrado/crt', _solicitacao,
                                {
                                    headers: {
                                        'x-access-token': user?.token2
                                    },
                                    params: {
                                        cnpj: solicitacao.cnpj
                                    }
                                }
                            )

                            setSolicitacao(result.data)

                        } catch (error) {
                            addToast(error.message, { appearance: 'error', autoDismiss: true })
                        }
                        setLoading(false)
                    }}>Continuar</Button>
            </Flex>
        </Flex>
    }

    function renderEtapa3() {
        return <Card>
            <Flex vertical gap={5}>

                <Alert banner type='info' showIcon description={
                    <Flex style={{ marginBottom: 10, fontStyle: 'italic' }}>
                        <b>Todos os documentos anexados devem ser no formato PDF.</b>
                    </Flex>
                } />

                <Card>
                    <Flex ><b>Tipo de Vínculo com a Empresa</b></Flex>
                    <Select
                        style={{ width: '100%' }}
                        value={solicitacao.vinculo}
                        onChange={(e) => {
                            setSolicitacao({ ...solicitacao, vinculo: e })
                        }}>
                        <option value={0}>Contratado / Empregado</option>
                        <option value={1}>Sócio / Proprietário</option>

                    </Select>
                </Card>

                <Divider style={{ marginTop: 5, marginBottom: 5 }} />

                <Badge.Ribbon color={'green'} text="obrigatório">
                    <Card title={null} style={{ backgroundColor: '#fcfcfc' }}>

                        <Flex gap={20}>
                            <Flex vertical flex={1}>
                                <Flex gap={5} align='center' style={{ fontWeight: 'bold' }}>{'Anexe o formulário baixado e assinado digitalmente'}</Flex>
                                <Flex style={{ fontSize: '0.8em', color: 'gray', fontStyle: 'italic' }}>O formulário deve estar assinado pela empresa e o profissional.</Flex>

                                <Flex vertical>
                                    <Upload {...props}
                                        defaultFileList={solicitacao.url_formulario && [
                                            {
                                                uid: '1',
                                                name: 'formulario.pdf',
                                                status: 'done',
                                                url: 'http://www.baidu.com/xxx.png',
                                                percent: 100,
                                            }
                                        ]}

                                        onRemove={async (file) => {
                                            setLoading(true)
                                            try {
                                                await api.delete('api/v1.0/upload/crt',
                                                    {
                                                        headers: {
                                                            'x-access-token': user?.token2
                                                        },
                                                        params: {
                                                            id: solicitacao.id,
                                                            iscontrato: 0
                                                        }
                                                    }
                                                )
                                                setSolicitacao({ ...solicitacao, url_formulario: '' })

                                            } catch (error) {
                                                addToast(error.message, { appearance: 'error', autoDismiss: true })
                                            }
                                            setLoading(false)
                                        }}
                                        headers={
                                            {
                                                'x-access-token': user?.token2,
                                            }
                                        }
                                        name="file"
                                        maxCount={1}
                                        showUploadList={true}
                                        data={{ ...solicitacao, iscontrato: 0 }}
                                        action={BASEURL.concat('api/v1.0/upload/crt')}
                                        beforeUpload={async (file) => {
                                            const isJpgOrPng = file.type === 'application/pdf';
                                            let isLt2M = file.size / 1024 / 1024 / 1024 / 1024 / 1024 < 5;
                                            try {
                                                if (!isJpgOrPng) {
                                                    console.log('Você só pode fazer upload de documentos no formato PDF!')
                                                    addToast('Você só pode fazer upload de documentos no formato PDF!', { appearance: 'error', autoDismiss: true });
                                                }

                                                if (!isLt2M) {
                                                    //   console.log('A imagem deve ser menor que 3MB!')
                                                    addToast('O documento não poder ser maior que 5mb!', { appearance: 'error', autoDismiss: true });
                                                    // message.error('A imagem deve ser menor que 3MB!');
                                                }
                                            } catch (error) {
                                                isLt2M = false
                                            }
                                            // console.log('beforeUpload', isJpgOrPng, isLt2M)
                                            return isJpgOrPng && isLt2M;
                                        }}

                                        onChange={(info) => {
                                            // console.log('onChange', info.file.status)
                                            setSolicitacao({ ...solicitacao, anexo: false })
                                            if (info.file.status === 'uploading') {
                                                setLoading(true)
                                                return;
                                            }
                                            if (info.file.status === 'done') {
                                                // console.log("INFO:",info.file.response.filename)
                                                // setSolicitacao({ ...solicitacao, anexo: true })
                                                setLoading(false)
                                                setSolicitacao({ ...solicitacao, url_formulario: "formulario.pdf" })
                                                //  setProduto({ ...produto, url: BASEURLRAIZ.concat('products/', info.file.response.filename) })
                                            }

                                            if (info.file.status === 'error') {
                                                // Get this url from response in real world.
                                                addToast(info?.file.response?.error, { autoDismiss: true, appearance: 'error' })
                                                console.log('INFO', info)
                                                info.fileList.pop()
                                                setLoading(false)
                                                return;
                                            }
                                            if (info.file.status === undefined) {
                                                setLoading(false)
                                                info.fileList.pop()
                                                return;
                                            }

                                            console.log("tamanho", info.fileList.length)
                                        }}
                                        onPreview={() => {

                                        }}

                                    >
                                        <Button icon={<UploadOutlined />}>Anexar Fomulario</Button>
                                    </Upload>
                                </Flex>
                            </Flex>

                            <Flex vertical flex={1}>
                                <Flex gap={5} align='center' style={{ fontWeight: 'bold' }}>{solicitacao.vinculo === 0 ? "Anexe o Contrato de Trabalho." : 'Anexe o Contrato Social'}</Flex>
                                {solicitacao.vinculo === 0 && <Flex style={{ fontSize: '0.8em', color: 'gray', fontStyle: 'italic' }}>O contrato deve conter carga horário e salário.</Flex>}
                                <Flex vertical>
                                    <Upload {...props}
                                        defaultFileList={solicitacao.url_contrato && [
                                            {
                                                uid: '1',
                                                name: 'contrato.pdf',
                                                status: 'done',
                                                url: 'http://www.baidu.com/xxx.png',
                                                percent: 100,
                                            }
                                        ]}
                                        onRemove={async (file) => {
                                            setLoading(true)
                                            try {
                                                await api.delete('api/v1.0/upload/crt',
                                                    {
                                                        headers: {
                                                            'x-access-token': user?.token2
                                                        },
                                                        params: {
                                                            id: solicitacao.id,
                                                            iscontrato: 1
                                                        }
                                                    }
                                                )
                                                setSolicitacao({ ...solicitacao, url_contrato: '' })
                                            } catch (error) {
                                                addToast(error.message, { appearance: 'error', autoDismiss: true })
                                            }
                                            setLoading(false)
                                        }}
                                        headers={
                                            {
                                                'x-access-token': user?.token2,
                                            }
                                        }
                                        name="file"
                                        maxCount={1}
                                        showUploadList={true}
                                        data={{ ...solicitacao, iscontrato: 1 }}
                                        action={BASEURL.concat('api/v1.0/upload/crt')}
                                        beforeUpload={async (file) => {
                                            const isJpgOrPng = file.type === 'application/pdf';
                                            let isLt2M = file.size / 1024 / 1024 / 1024 / 1024 / 1024 < 5;
                                            try {
                                                if (!isJpgOrPng) {
                                                    console.log('Você só pode fazer upload de documentos no formato PDF!')
                                                    addToast('Você só pode fazer upload de documentos no formato PDF!', { appearance: 'error', autoDismiss: true });
                                                }

                                                if (!isLt2M) {
                                                    //   console.log('A imagem deve ser menor que 3MB!')
                                                    addToast('O documento não poder ser maior que 5mb!', { appearance: 'error', autoDismiss: true });
                                                    // message.error('A imagem deve ser menor que 3MB!');
                                                }
                                            } catch (error) {
                                                isLt2M = false
                                            }
                                            // console.log('beforeUpload', isJpgOrPng, isLt2M)
                                            return isJpgOrPng && isLt2M;
                                        }}

                                        onChange={(info) => {


                                            if (info.file.status === 'uploading') {
                                                setLoading(true)
                                                return;
                                            }
                                            if (info.file.status === 'done') {
                                                // console.log('onChange', info.file.status)
                                                setSolicitacao({ ...solicitacao, url_contrato: "contrato.pdf" })
                                                setLoading(false)
                                                //  setProduto({ ...produto, url: BASEURLRAIZ.concat('products/', info.file.response.filename) })
                                            }

                                            if (info.file.status === 'error') {
                                                // Get this url from response in real world.
                                                addToast(info?.file.response?.error, { autoDismiss: true, appearance: 'error' })
                                                console.log('INFO', info)
                                                info.fileList.pop()
                                                setLoading(false)
                                                return;
                                            }
                                            if (info.file.status === undefined) {
                                                setLoading(false)
                                                info.fileList.pop()
                                                console.log("tamanho", info.fileList.length)
                                                return;
                                            }

                                            console.log("tamanho", info.fileList.length)
                                        }}
                                        onPreview={() => {

                                        }}

                                    >
                                        <Button icon={<UploadOutlined />}>Anexar Contrato</Button>
                                    </Upload>
                                </Flex>
                            </Flex>
                        </Flex>



                    </Card>
                </Badge.Ribbon>

                <Divider style={{ marginTop: 5, marginBottom: 5 }} />

                <Badge.Ribbon color={'#cdcdcd'} text={<Flex style={{ color: '#323131' }}>opcional</Flex>}>
                    <Card title={null} style={{ backgroundColor: '#fcfcfc' }}>
                        <Flex gap={20}>
                            <Flex vertical flex={1}>
                                <Flex gap={5} align='center' style={{ fontWeight: 'bold' }}>Outro arquivo.</Flex>
                                <Flex vertical>
                                    <Upload {...props}
                                        defaultFileList={solicitacao.outros2 && [
                                            {
                                                uid: '1',
                                                name: 'arquivo.pdf',
                                                status: 'done',
                                                url: 'http://www.baidu.com/xxx.png',
                                                percent: 100,
                                            }
                                        ]}
                                        onRemove={async (file) => {
                                            setLoading(true)
                                            try {
                                                await api.delete('api/v1.0/upload/crt',
                                                    {
                                                        headers: {
                                                            'x-access-token': user?.token2
                                                        },
                                                        params: {
                                                            id: solicitacao.id,
                                                            iscontrato: 2
                                                        }
                                                    }
                                                )
                                                setSolicitacao({ ...solicitacao, outros2: '' })
                                            } catch (error) {
                                                addToast(error.message, { appearance: 'error', autoDismiss: true })
                                            }
                                            setLoading(false)
                                        }}
                                        headers={
                                            {
                                                'x-access-token': user?.token2,
                                            }
                                        }
                                        name="file"
                                        maxCount={1}
                                        showUploadList={true}
                                        data={{ ...solicitacao, iscontrato: 2 }}
                                        action={BASEURL.concat('api/v1.0/upload/crt')}
                                        beforeUpload={async (file) => {
                                            const isJpgOrPng = file.type === 'application/pdf';
                                            let isLt2M = file.size / 1024 / 1024 / 1024 / 1024 / 1024 < 5;
                                            try {
                                                if (!isJpgOrPng) {
                                                    console.log('Você só pode fazer upload de documentos no formato PDF!')
                                                    addToast('Você só pode fazer upload de documentos no formato PDF!', { appearance: 'error', autoDismiss: true });
                                                }

                                                if (!isLt2M) {
                                                    //   console.log('A imagem deve ser menor que 3MB!')
                                                    addToast('O documento não poder ser maior que 5mb!', { appearance: 'error', autoDismiss: true });
                                                    // message.error('A imagem deve ser menor que 3MB!');
                                                }
                                            } catch (error) {
                                                isLt2M = false
                                            }
                                            // console.log('beforeUpload', isJpgOrPng, isLt2M)
                                            return isJpgOrPng && isLt2M;
                                        }}

                                        onChange={(info) => {
                                            // console.log('onChange', info.file.status)
                                            setSolicitacao({ ...solicitacao, anexo: false })
                                            if (info.file.status === 'uploading') {
                                                setLoading(true)
                                                return;
                                            }
                                            if (info.file.status === 'done') {
                                                // console.log("INFO:",info.file.response.filename)
                                                setSolicitacao({ ...solicitacao, anexo: true })
                                                setLoading(false)
                                                //  setProduto({ ...produto, url: BASEURLRAIZ.concat('products/', info.file.response.filename) })
                                            }

                                            if (info.file.status === 'error') {
                                                // Get this url from response in real world.
                                                addToast(info?.file.response?.error, { autoDismiss: true, appearance: 'error' })
                                                console.log('INFO', info)
                                                info.fileList.pop()
                                                setLoading(false)
                                                return;
                                            }
                                            if (info.file.status === undefined) {
                                                setLoading(false)
                                                info.fileList.pop()
                                                console.log("tamanho", info.fileList.length)
                                                return;
                                            }

                                            console.log("tamanho", info.fileList.length)
                                        }}
                                        onPreview={() => {

                                        }}

                                    >
                                        <Button icon={<UploadOutlined />}>Anexar</Button>
                                    </Upload>
                                </Flex>
                            </Flex>

                            <Flex vertical flex={1}>
                                <Flex gap={5} align='center' style={{ fontWeight: 'bold' }}>Outro arquivo.</Flex>
                                <Flex vertical>
                                    <Upload {...props}
                                        defaultFileList={solicitacao.outros3 && [
                                            {
                                                uid: '1',
                                                name: 'arquivo.pdf',
                                                status: 'done',
                                                url: 'http://www.baidu.com/xxx.png',
                                                percent: 100,
                                            }
                                        ]}
                                        onRemove={async (file) => {
                                            setLoading(true)
                                            try {
                                                await api.delete('api/v1.0/upload/crt',
                                                    {
                                                        headers: {
                                                            'x-access-token': user?.token2
                                                        },
                                                        params: {
                                                            id: solicitacao.id,
                                                            iscontrato: 3
                                                        }
                                                    }
                                                )
                                                setSolicitacao({ ...solicitacao, outros3: '' })
                                            } catch (error) {
                                                addToast(error.message, { appearance: 'error', autoDismiss: true })
                                            }
                                            setLoading(false)
                                        }}
                                        headers={
                                            {
                                                'x-access-token': user?.token2,
                                            }
                                        }
                                        name="file"
                                        maxCount={1}
                                        showUploadList={true}
                                        data={{ ...solicitacao, iscontrato: 3 }}
                                        action={BASEURL.concat('api/v1.0/upload/crt')}
                                        beforeUpload={async (file) => {
                                            const isJpgOrPng = file.type === 'application/pdf';
                                            let isLt2M = file.size / 1024 / 1024 / 1024 / 1024 / 1024 < 5;
                                            try {
                                                if (!isJpgOrPng) {
                                                    console.log('Você só pode fazer upload de documentos no formato PDF!')
                                                    addToast('Você só pode fazer upload de documentos no formato PDF!', { appearance: 'error', autoDismiss: true });
                                                }

                                                if (!isLt2M) {
                                                    //   console.log('A imagem deve ser menor que 3MB!')
                                                    addToast('O documento não poder ser maior que 5mb!', { appearance: 'error', autoDismiss: true });
                                                    // message.error('A imagem deve ser menor que 3MB!');
                                                }
                                            } catch (error) {
                                                isLt2M = false
                                            }
                                            // console.log('beforeUpload', isJpgOrPng, isLt2M)
                                            return isJpgOrPng && isLt2M;
                                        }}

                                        onChange={(info) => {
                                            // console.log('onChange', info.file.status)
                                            setSolicitacao({ ...solicitacao, anexo: false })
                                            if (info.file.status === 'uploading') {
                                                setLoading(true)
                                                return;
                                            }
                                            if (info.file.status === 'done') {
                                                // console.log("INFO:",info.file.response.filename)
                                                setSolicitacao({ ...solicitacao, anexo: true })
                                                setLoading(false)
                                                //  setProduto({ ...produto, url: BASEURLRAIZ.concat('products/', info.file.response.filename) })
                                            }

                                            if (info.file.status === 'error') {
                                                // Get this url from response in real world.
                                                addToast(info?.file.response?.error, { autoDismiss: true, appearance: 'error' })
                                                console.log('INFO', info)
                                                info.fileList.pop()
                                                setLoading(false)
                                                return;
                                            }
                                            if (info.file.status === undefined) {
                                                setLoading(false)
                                                info.fileList.pop()
                                                console.log("tamanho", info.fileList.length)
                                                return;
                                            }

                                            console.log("tamanho", info.fileList.length)
                                        }}
                                        onPreview={() => {

                                        }}

                                    >
                                        <Button icon={<UploadOutlined />}>Anexar</Button>
                                    </Upload>
                                </Flex>
                            </Flex>
                        </Flex>
                    </Card>
                </Badge.Ribbon>


            </Flex>

            <Flex justify='flex-end' gap={30} style={{ marginTop: 30 }}>
                <Button onClick={() => setSolicitacao({ ...solicitacao, etapa: 1 })}>Voltar</Button>
                <Button
                    disabled={!solicitacao.url_contrato || !solicitacao.url_formulario}
                    loading={loading}
                    iconPlacement='end' icon={<RightOutlined />}
                    type='primary' onClick={async () => {
                        try {
                            let _solicitacao = JSON.parse(JSON.stringify(solicitacao))
                            _solicitacao.etapa = 3
                            _solicitacao.aceite = 0
                            setLoading(true)
                            const result = await api.post('/api/v1.0/registrado/crt', _solicitacao,
                                {
                                    headers: {
                                        'x-access-token': user?.token2
                                    },
                                    params: {
                                        cnpj: solicitacao.cnpj
                                    }
                                }
                            )

                            setSolicitacao(result.data)

                        } catch (error) {
                            addToast(error.message, { appearance: 'error', autoDismiss: true })
                        }
                        setLoading(false)
                    }}>Continuar</Button>
            </Flex>

        </Card>
    }

    function renderEtapa4() {
        return <Flex vertical gap={10}>
            <Card style={{ backgroundColor: 'white' }}>
                <Flex vertical gap={5}>
                    <Flex vertical gap={10}>
                        <Flex><b>Termo de Responsabilidade</b></Flex>
                        <Flex>
                            Declaro, na qualidade de Profissional da Química regularmente registrado(a), que todas as informações prestadas na Comunicação de Responsabilidade Técnica (CRT) são verdadeiras, completas e de minha inteira responsabilidade.
                        </Flex>
                        <Flex>
                            Declaro ainda que os documentos anexados são autênticos e correspondem fielmente aos documentos originais, estando ciente de que a prestação de informações falsas, inexatas ou a apresentação de documentos inverídicos poderá acarretar o indeferimento ou cancelamento da solicitação, bem como a aplicação das sanções administrativas, civis e penais cabíveis, conforme a legislação vigente e as normas do Conselho Regional de Química da 10ª Região.
                        </Flex>
                        <Flex>
                            Comprometo-me a comunicar imediatamente qualquer alteração nas informações declaradas que possa impactar a Responsabilidade Técnica assumida.
                        </Flex>
                        <Flex>
                            Estou ciente de que este aceite eletrônico possui validade jurídica, sendo equivalente à assinatura presencial.
                        </Flex>
                    </Flex>

                    <Checkbox style={{ marginTop: 15 }} value={solicitacao.aceite} onChange={(e) => setSolicitacao({ ...solicitacao, aceite: e.target.checked ? 1 : 0 })}>
                        <b> Declaro que li e concordo com o Termo de Responsabilidade acima.</b></Checkbox>

                    {/*
                <Alert banner
                    type='info'
                    description="O Conselho Regional de Química da 10 Região analisará os documentos enviados, acompanhe o status da sua solicitação por esse canal." />
              */}



                </Flex>
            </Card>

            <Flex gap={10} justify='flex-end'>

                <Button onClick={async () => {
                    setSolicitacao({ ...solicitacao, etapa: 2 })
                }}> Voltar </Button>

                <Button
                    loading={loading}
                    icon={<SendOutlined />}
                    disabled={solicitacao.aceite !== 1}
                    type='primary'
                    onClick={async () => {
                        let _solicitacao = JSON.parse(JSON.stringify(solicitacao))
                        _solicitacao.etapa = 4
                        setLoading(true)
                        try {
                            await api.post('/api/v1.0/registrado/crt', _solicitacao,
                                {
                                    headers: {
                                        'x-access-token': user?.token2
                                    },
                                }
                            )
                            addToast("Solicitação efetuada com sucesso!", { appearance: 'success', autoDismiss: true })
                            //setOpen(false)
                            props.crqSolicitacoes()
                            props.setOpenSelected(false)



                        } catch (error) {
                            addToast(error.message, { appearance: 'error', autoDismiss: true })
                        }
                        setLoading(false)

                    }}> Enviar </Button>
            </Flex>
        </Flex>
    }

    return <Flex vertical gap={10}>
        <Flex align='center' justify='space-between'>
            <Breadcrumb items={[
                {
                    title: <Flex align='center' gap={5}><FileTextOutlined /> Comunicações de Responsabilidade Técnica</Flex>,
                }, {
                    title: "Nova"
                }
            ]} />

            <Button type='link' size='large' icon={<CloseOutlined />} onClick={() => {
                props.setOpenSelected(false)
                props.crqSolicitacoes()
            }}></Button>
        </Flex>





        <Flex vertical style={{ padding: 15 }} gap={5}>
            <Steps current={solicitacao.etapa} percent={80} size="small" items={items} style={{ marginBottom: 15 }} />
            {renderEtapas()}
        </Flex>
    </Flex>




}